(()=>{'use strict';
 const nav=document.querySelector('.flayvr-taste-nav');if(!nav)return;
 const profile=nav.querySelector('[data-flayvr-tab="profile"]'),guide=nav.querySelector('[data-flayvr-tab="guide"]'),hood=nav.querySelector('[data-flayvr-tab="neighbourhood"]');
 const keep=['tp_axes','tp_b','p'];
 const safeGet=(k)=>{try{return sessionStorage.getItem(k)||''}catch{return''}};
 const safeSet=(k,v)=>{try{sessionStorage.setItem(k,v)}catch{}};
 function sync(){
  const url=new URL(location.href);const ps=url.searchParams;
  for(const k of keep){const v=ps.get(k);if(v&&v.length<3000)safeSet('flayvr_journey_'+k,v);}
  // The live results page creates its guide URL after completing the quiz.
  const existing=[...document.querySelectorAll('a[href*="tp_axes="]')].find(a=>!a.closest('.flayvr-taste-nav'));
  if(existing){try{const q=new URL(existing.href,location.href).searchParams;for(const k of ['tp_axes','tp_b']){const v=q.get(k);if(v&&v.length<3000)safeSet('flayvr_journey_'+k,v)}}catch{}}
  const token=ps.get('p')||safeGet('flayvr_journey_p');
  const codec=window.TasteProfileCodecV173;
  if(token&&codec&&typeof codec.decode==='function'){
   const profile=codec.decode(token);
   if(profile&&['adv','heat','intensity','acid','texture','sweet'].every(k=>Number.isInteger(profile[k])))safeSet('flayvr_journey_tp_axes',['adv','heat','intensity','acid','texture','sweet'].map(k=>profile[k]).join(','));
  }
  const params=new URLSearchParams();for(const k of keep){const v=(k==='tp_axes'?safeGet('flayvr_journey_tp_axes'):ps.get(k))||safeGet('flayvr_journey_'+k);if(v)params.set(k,v)}
  const suffix=params.toString()?'?'+params:'';
  if(guide.getAttribute('href')!=='/pages/london-restaurant-guide-matched-to-your-taste'+suffix)guide.href='/pages/london-restaurant-guide-matched-to-your-taste'+suffix;
  if(hood.getAttribute('href')!=='/pages/taste-neighbourhood'+suffix)hood.href='/pages/taste-neighbourhood'+suffix;
  const onProfile=/^taste-profile-(test|results)$/.test(nav.dataset.currentPage||'');
  if(onProfile&&(ps.has('p')||ps.has('tp_axes')))safeSet('flayvr_journey_result_path',url.pathname+url.search);
  const profileTarget=safeGet('flayvr_journey_result_path')||'/pages/taste-profile-test';if(profile.getAttribute('href')!==profileTarget)profile.href=profileTarget;
 }
 function positionJourney(){
   const hood=document.querySelector('#flayvr-neighbourhood-root');
   if(hood){
     const sidebar=hood.querySelector('.sidebar-top');if(sidebar&&nav.parentElement!==sidebar)sidebar.insertBefore(nav,sidebar.firstChild);return;
   }
   const tpv=document.querySelector('[data-tpv-root]');
   if(tpv){
     const results=tpv.querySelector('[data-tpv-results]');const shown=results&&!results.hidden;
     const anchor=shown?results.querySelector('.tpv-results-hero'):tpv.querySelector('.tpv-test .tpv-intro');
     if(anchor&&nav.previousElementSibling!==anchor)anchor.insertAdjacentElement('afterend',nav);
   }
 }
 sync();positionJourney();let tabTicks=0;const tabInterval=setInterval(()=>{positionJourney();if(++tabTicks>=90)clearInterval(tabInterval)},250);let timer=0;const obs=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(sync,200)});
 obs.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
 addEventListener('popstate',sync);setTimeout(()=>obs.disconnect(),30000);
})();
